import React, { useState } from 'react';
import styles from './Contact.module.css';
import Title from '../helper/Title';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';


export default function Contact() {
  const [errorFields, setErrorFields] = useState({
    mail: false,
    message: false,
  });

  const handleSend = () => {
    // Her bir input alanının değerini al
    const mailValue = document.getElementById('required-mail').value.trim();
    const messageValue = document.getElementById('required-message').value.trim();

    // Boş olan alanları kontrol et
    const mailError = mailValue === '';
    const messageError = messageValue === '';

    // Hatalı alanları işaretle
    setErrorFields({
      mail: mailError,
      message: messageError,
    });

    // Eğer herhangi bir hatalı alan varsa, gönderme işlemi durdur
    if (mailError || messageError) {
      return;
    }

  };

  return (
    <section className={styles.section} id="contact">
      <Title className={styles.sectiontitle} title='- contact' subTitle='-' />
      
        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { m: 1, width: '45ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <div className={styles.one}>
            <TextField
              className={styles.inputone}
              id="required-mail"
              label="Mail"
              placeholder='Mail Adresinizi Yazınız.'
              required
              error={errorFields.mail}
              helperText={errorFields.mail ? "Lütfen bu alanı doldurun." : ""}
            />
          </div>

          <div className={styles.two}>
            <TextField
              className={styles.inputtwo}
              id="required-message"
              label="Mesaj"
              placeholder='Mesajınızı Yazınız.'
              required
              error={errorFields.message}
              helperText={errorFields.message ? "Lütfen bu alanı doldurun." : ""}
            />
          </div>
          
            <a variant="contained" onClick={handleSend} className={styles.btn}>GÖNDER</a>
        </Box>
     
    </section>
  );
}
